import { render } from "./PersonaContactoModal.vue?vue&type=template&id=4541ef84"
import script from "./PersonaContactoModal.vue?vue&type=script&lang=js"
export * from "./PersonaContactoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__